import { render } from "./CustomerListPage.vue?vue&type=template&id=381af7e4&scoped=true&ts=true"
import script from "./CustomerListPage.vue?vue&type=script&lang=ts"
export * from "./CustomerListPage.vue?vue&type=script&lang=ts"

import "./CustomerListPage.vue?vue&type=style&index=0&id=381af7e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381af7e4"]])

export default __exports__